import * as angular from 'angular';

function onlyDecimal(): ng.IDirective {
    return {
        require: 'ngModel',
        restrict: 'A',
        link(scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, ctrl: ng.IController) {
            if (!ctrl) { return; }
            function inputValue(val: string) {
                if (angular.isUndefined(val)) { val = ''; }
                var clean = val.replace(/[^0-9\.]/g, '');
                clean = clean.slice(0, 16);
                let decimalCheck = clean.split('.');

                let maxCharInt = attrs.maxchar ? parseInt(attrs.maxchar, 10) : NaN;
                let maxCharDecimal = attrs.maxcharDecimal ? parseInt(attrs.maxcharDecimal, 10) : 2;

                let maxValue = attrs.maxValue ? parseFloat(attrs.maxValue) : NaN;
                let minValue = attrs.minValue ? parseFloat(attrs.minValue) : NaN;

                let isNumber = attrs.isNumber ? (attrs.isNumber === 'true') : false;

                if (maxCharInt) {
                    decimalCheck[0] = decimalCheck[0].slice(0, maxCharInt);
                    clean = decimalCheck[0];
                }
                if (!angular.isUndefined(decimalCheck[1])) {
                    decimalCheck[1] = decimalCheck[1].slice(0, maxCharDecimal);
                    clean = decimalCheck[0] + '.' + decimalCheck[1];
                }
                if (maxValue && maxValue <= parseFloat(clean)) {
                    clean = maxValue.toString();
                }
                if (minValue && minValue > parseFloat(clean)) {
                    clean = '';
                }

                if (val !== clean) {
                    ctrl.$setViewValue(clean);
                    ctrl.$render();
                }
                return isNumber ? parseFloat(clean) : clean;
            }

            ctrl.$parsers.push(inputValue);

            element.bind('keypress', function (event: JQueryEventObject) {
                if (event.keyCode === 32) {
                    event.preventDefault();
                }
            });
        }
    };
}

angular
    .module('app.common')
    .directive('onlyDecimal', onlyDecimal);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/only-decimal.directive.ts